module.exports = __webpack_public_path__ + "static/media/ice28.4162dac1.webp";